module.exports = __webpack_public_path__ + "static/media/fondo2.0c6a20eb.svg";